import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DateFieldType } from "../../../types/document-management/document-management-types";
import dayjs from "dayjs";

interface DatePickerFieldProps {
  value: DateFieldType;
  label: string;
  onChange: (value: DateFieldType) => void;
  minDate?: dayjs.Dayjs | undefined;
  maxDate?: dayjs.Dayjs | undefined;
}
const DatePickerField: React.FC<DatePickerFieldProps> = ({ value, label, onChange, maxDate, minDate }) => {
  return (
    <DatePicker
      minDate={minDate}
      maxDate={maxDate}
      disableFuture
      label={label}
      openTo="day"
      views={["year", "month", "day"]}
      renderInput={(params) => <TextField size="small" {...params} />}
      value={value}
      onChange={onChange}
    />
  );
};
export default DatePickerField;